import { useParams, Link } from 'react-router-dom';
import { categories, categoryData, comics as allComics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';
import { useState } from 'react';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeTab, setActiveTab] = useState<string>(slug || 'romance');

  const cat = categories.find(c => c.slug === activeTab);
  const comicList = categoryData[activeTab] || [];

  const handleTabChange = (newSlug: string) => {
    setActiveTab(newSlug);
    window.history.pushState(null, '', '/category/' + newSlug);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen">
      <section className="py-8 bg-background-100">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950">
              {cat ? cat.name + '漫画' : '漫画分类'}
            </h2>
            {cat && (
              <p className="text-sm text-foreground-600 mt-2 max-w-lg mx-auto">
                {cat.description}
              </p>
            )}
          </div>

          <div className="flex items-center justify-center mb-8">
            <div className="inline-flex bg-background-200/70 rounded-full p-1 flex-wrap gap-1 justify-center">
              {categories.map(c => (
                <button
                  key={c.slug}
                  onClick={() => handleTabChange(c.slug)}
                  className={
                    'px-4 py-2 text-sm font-medium rounded-full transition-all duration-200 whitespace-nowrap ' +
                    (activeTab === c.slug
                      ? 'bg-primary-500 text-white'
                      : 'text-foreground-600 hover:text-foreground-900 hover:bg-background-50')
                  }
                >
                  <i className={c.icon + ' mr-1'}></i>
                  {c.name}
                </button>
              ))}
            </div>
          </div>

          {comicList.length > 0 ? (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {comicList.map(comic => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100">
                <i className="ri-emotion-sad-line text-2xl text-secondary-500"></i>
              </div>
              <p className="text-foreground-600">该分类暂无漫画，请查看其他分类</p>
            </div>
          )}
        </div>
      </section>

      <section className="py-10 md:py-14 bg-background-50">
        <div className="max-w-7xl mx-auto px-4 md:px-6">
          <h3 className="text-lg font-heading text-foreground-950 mb-6">你可能也喜欢</h3>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
            {allComics
              .filter(c => c.categorySlug !== activeTab)
              .slice(0, 5)
              .map(comic => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
          </div>
        </div>
      </section>
    </div>
  );
}